import { useOnboardingStatus } from 'src/hooks/useOnboardingStatus'
import { CuiMealCardLoading } from 'front-lib'
import { useOnboardingSteps } from 'src/hooks/useOnboardingSteps'

import '../OnboardingHub.scss'

export function BasicsSection() {
  const { onboardingStatus, loading } = useOnboardingStatus()
  const { getStepComponent } = useOnboardingSteps()

  return (
    <div className="onboarding-basics-section">
      <h2 className="onboarding-hub__title">Level up your experience</h2>
      <p className="onboarding-hub__description">
        Get the most out of CookUnity in just a few quick steps.
      </p>
      <div className="onboarding-basics-section__container">
        {loading ? (
          <>
            <CuiMealCardLoading />
            <CuiMealCardLoading />
            <CuiMealCardLoading />
            <CuiMealCardLoading />
          </>
        ) : (
          <div className="onboarding-basics-section__steps">
            {onboardingStatus.map(step => {
              const stepComponent = getStepComponent(step)
              return stepComponent && <div key={step.name}>{stepComponent}</div>
            })}
          </div>
        )}
      </div>
    </div>
  )
}
